var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTinytap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TinyTap",
    transform: "translate(-117 -365)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1303",
    "data-name": "Ellipse 1303",
    cx: 86,
    cy: 86,
    r: 86,
    transform: "translate(117 365)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "tiny_logo",
    "data-name": "tiny logo",
    transform: "translate(127.582 375.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(26.987 43.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M133.729,71.274a2.639,2.639,0,1,1,2.26-2.972A2.64,2.64,0,0,1,133.729,71.274Zm-.669-4.913a2.319,2.319,0,1,0,2.612,1.985A2.32,2.32,0,0,0,133.06,66.361Zm1.79,3.475c-.116.016-.189.014-.334.035-.31.042-.416-.179-.453-.448l-.032-.235c-.02-.149-.043-.313-.192-.38-.1-.043-.162-.046-.528,0-.258.035-.355.075-.335.228l.026.19a2.629,2.629,0,0,0,.082.46.168.168,0,0,0,.2.114c.059-.008.117-.035.177-.043a.121.121,0,0,1,.136.111c.012.089-.06.145-.142.156-.153.021-.316,0-.506.027s-.308.083-.494.109a.145.145,0,0,1-.179-.112.121.121,0,0,1,.1-.144c.06-.008.122,0,.182-.006a.168.168,0,0,0,.164-.163,2.814,2.814,0,0,0-.044-.465l-.125-.915a2.7,2.7,0,0,0-.082-.46.168.168,0,0,0-.2-.113c-.06.008-.117.035-.177.043a.121.121,0,0,1-.137-.111.144.144,0,0,1,.142-.156c.22-.03.413-.014.6-.04.318-.043.521-.113.686-.135a1.116,1.116,0,0,1,.587.038.623.623,0,0,1,.344.489c.053.392-.148.587-.5.7v.008c.391-.008.488.2.536.554l.025.179c.023.172.04.272.25.243.056-.008.114-.027.17-.035a.135.135,0,0,1,.168.114A.143.143,0,0,1,134.85,69.835Zm-1.006-1.441a.416.416,0,0,0,.138-.41c-.048-.355-.319-.417-.652-.371-.415.056-.528.144-.509.282l.083.609c.012.09.024.1.129.082l.306-.042A1.212,1.212,0,0,0,133.843,68.395ZM130.81,80.359l-4.117,5.411a5.907,5.907,0,0,1-.785.84l.46,3.384a5.877,5.877,0,0,1-11.647,1.585l-.509-3.745c-.151-.095-.3-.194-.446-.305l-5.414-4.114a5.876,5.876,0,0,1,7.115-9.353l3.4,2.584,2.586-3.4a5.876,5.876,0,0,1,9.356,7.111ZM106.683,95.47c-.015.041-.032.082-.048.123a5.878,5.878,0,0,1-9.03,2.534l-4.418-3.411a5.876,5.876,0,0,1-11.672,1.353L79.758,83.159A5.877,5.877,0,0,1,89.2,77.735c.037.027.075.053.112.08l4.267,3.341a5.876,5.876,0,0,1,11.654-1.512L107,92.634a5.842,5.842,0,0,1-.294,2.782Zm-31.395,7.415a5.876,5.876,0,0,1-6.616-5.028L66.908,84.893a5.877,5.877,0,0,1,11.647-1.586l1.764,12.965A5.876,5.876,0,0,1,75.288,102.885Zm-14.1-11.276-.752.1.971,7.134a5.877,5.877,0,0,1-11.647,1.585L48.794,93.3l-.749.1A5.874,5.874,0,1,1,46.46,81.757l13.148-1.79a5.874,5.874,0,1,1,1.585,11.641Zm.485,13.721,13.149-1.789a5.874,5.874,0,1,1,1.584,11.641l-.753.1.971,7.132A5.877,5.877,0,0,1,64.982,124l-.971-7.131-.749.1a5.874,5.874,0,1,1-1.584-11.641Zm23.106.3a5.875,5.875,0,0,1,4.695-4.069c.044-.007.087-.012.131-.018s.087-.012.13-.017a5.877,5.877,0,0,1,5.611,2.665l8.546,11.831a5.876,5.876,0,0,1-9.294,7.193l-2.52-3.488-1.5,4.034a5.876,5.876,0,0,1-10.878-4.448Zm24.394-6.718c.312-.042.526-.063.917-.124l5.045-.687a7.905,7.905,0,0,1,8.9,6.765c.528,3.874-3.059,7.637-6.923,8.8l.455,3.341a5.877,5.877,0,0,1-11.647,1.586l-1.788-13.142A5.815,5.815,0,0,1,109.178,98.908Z",
    transform: "translate(-41.375 -66.019)",
    fill: "#55baeb",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(5.091 6.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M13.464,57.28a5.663,5.663,0,0,1-5.255-7.755A72.6,72.6,0,0,1,21.144,29.432,77.048,77.048,0,0,1,45.158,11.047,5.658,5.658,0,1,1,50.03,21.262C34.442,28.7,22.874,43.3,18.722,53.715A5.661,5.661,0,0,1,13.464,57.28Z",
    transform: "translate(-7.806 -10.495)",
    fill: "#e73156"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 57.068)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M7.573,127.573a5.66,5.66,0,0,1-5.479-4.263C-.95,111.366-.138,96.6,1.171,91.695a5.658,5.658,0,1,1,10.934,2.917c-.838,3.141-1.541,16.109.954,25.9a5.664,5.664,0,0,1-5.487,7.057Z",
    transform: "translate(0 -87.493)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(7.062 99.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M19.205,169.583a5.657,5.657,0,0,1-4.973-2.951l-2.713-4.977a5.658,5.658,0,1,1,9.936-5.417l2.713,4.977a5.66,5.66,0,0,1-4.963,8.368Z",
    transform: "translate(-10.828 -153.287)",
    fill: "#7cb94b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(26.497)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M89.084,150.018a74.254,74.254,0,0,1-46.3-15.989,5.658,5.658,0,1,1,6.99-8.9A63.041,63.041,0,0,0,89.084,138.7,63.692,63.692,0,1,0,74.63,12.962,5.658,5.658,0,0,1,72.073,1.938,75.387,75.387,0,0,1,89.084,0a75.009,75.009,0,0,1,53.039,128.048A74.516,74.516,0,0,1,89.084,150.018Z",
    transform: "translate(-40.623 0)",
    fill: "#55baeb"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinytap);
export default __webpack_public_path__ + "static/media/tinytap.e433ee074f234e3da575a17e614e2a58.svg";
export { ForwardRef as ReactComponent };